// pairing.engine.ts
import { RowType, Reservation } from "src/app/models";

export function getPairIds(
  reservations: Reservation[],
  resId: string
): {
  aircraftId: string | null;
  instructorId: string | null;
} {
  const a =
    reservations.find((x) => x.id === resId && x.rowType === "aircraft")
      ?.rowId ?? null;
  const i =
    reservations.find((x) => x.id === resId && x.rowType === "instructor")
      ?.rowId ?? null;
  return { aircraftId: a, instructorId: i };
}

export function otherType(t: RowType): RowType {
  return t === "aircraft" ? "instructor" : "aircraft";
}
